module.exports = __webpack_public_path__ + "static/media/bolinhadequeijo.29b2a801.webp";